import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-item-set-selector-dialog',
  templateUrl: './item-set-selector-dialog.component.html',
  styleUrls: ['./item-set-selector-dialog.component.scss']
})
export class ItemSetSelectorDialogComponent implements OnInit {
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  selectedSetId: number | null = null;
  filteredItemSets: any[] = [];

  ngOnInit() {
    this.filteredItemSets = this.config.data.itemSets.filter(
      (set: any) => set.id !== this.config.data.currentSetId
    );
  }

  confirmSelection() {
    console.log('[Confirm] selectedSetId =', this.selectedSetId); 
    if (this.selectedSetId != null) {
      this.ref.close(this.selectedSetId);
    }
  }

  cancel() {
    this.ref.close();
  }
} 